import Link from "next/link";

interface TitleTagProps {
  content: string;
  // Set false when the tag is already inside another link, to avoid nested <a>
  link?: boolean;
}

export default function TitleTag({ content, link = true }: TitleTagProps) {
  const isPrintEdition =
    link && content.trim().toLowerCase() === "print edition";

  const className =
    "inline-block bg-[#fdeced] text-[#ec1c34] px-[5px] py-1 rounded text-[10px] font-montserrat uppercase font-[600] mr-1 mb-1 leading-none align-middle";

  if (isPrintEdition) {
    return (
      <>
        <Link href="/print-edition" className={className}>
          {content}
        </Link>{" "}
      </>
    );
  }

  return (
    <>
      <span className={className}>
        {content}
      </span>{" "}
    </>
  );
}